import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { Assets, BitmapText, Container, Graphics, Text } from "pixi.js";
import { Tween } from "tweedle.js";
import { JackpotUpgradeComponent } from "../components/jackpot/JackpotUpgradeComponent";
import { ScarabWinsComponent } from "../components/jackpot/ScarabWinsComponent";
import { JackpotIntroBannerComponent } from "../components/jackpotbanner/JackpotIntroBannerComponent";
import { JackpotWinBannerComponent } from "../components/jackpotbanner/JackpotWinBannerComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
import { isSuperQuickBtnOnGlobal, languageGlobal, RespinIndex, setMaxWinBtnClosedGlobal, waitUntilMaxWinBtnClosed, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { getFontConfig } from "../config/introTextConfig";
import { REEL_SCALE_LANDSCAPE, REEL_SCALE_PORTRAIT, REEL_Y_POS_LAND, REEL_Y_POS_PORT, VISIBLE_SYMBOLS_PER_REEL } from "../config/reelConfig";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import {
    createUpgradeTitleStyle,
    JACKPOT_UPGRADE_AMOUNT_FONT_SIZE,
    JACKPOT_UPGRADE_TITLE_FONT_SIZE,
    layoutJackpotUpgradeText,
    parseJackpotUpgradeDesc,
} from "../core/jackpotUpgradeText";
import { Manager } from "../core/Manager";
import { reelSpinEmitter } from "../core/reels/ReelInit";
import { getJackpotEntryByIndex, wait } from "../core/utils";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { SoundConstants } from "../gameClientEvents/SoundConstants";
//import { PerformanceProfiler } from "../PerformanceProfiler";
import { spinData } from "../server/getServerResposesFun";
import { BaseGameScene } from "./BaseGameScene";
import { BaseScene } from "./BaseScene";
import { BigWin } from "./BigWin";

declare const window: any;
const translationManager = window.hacksawCasino.Translation;

export class FreeGameScene extends BaseScene {
    override assetBundles: string[] = ["free-screen", "sound", "intro-screen", "big-win"];
    override assets: string[] = ["free-screen", "intro-screen", "big-win"];
    private fgTransition: Spine | null = null;
    // private transitionChangePromise: Promise<void> | null = null;
    // private resolveTransitionChange: (() => void) | null = null;
    private numberOfFS: number;
    private baseGameWin: number;
    private totalFGSessionWin: number; // this is total win including base spin

    private firstSpin: boolean = true;
    private skipNextFeatureRoundStarted = false;

    private numberOfFSPlayed: number = 0;
    private jackpotUpgradeIndex: number = 0;
    private autoTriggerTimeout: ReturnType<typeof setTimeout>;
    private upgradeBlackLayer: Graphics = new Graphics();
    private boundShakeEffect: () => void;

    private pointerDownHandlerFree: () => void;


    constructor(numberOfFS: number, baseGameWin: number) {
        super();
        this.assetBundles = ["free-screen"];
        this.assets = ["free-screen"];
        this.numberOfFS = numberOfFS;
        this.numberOfFSPlayed = 0;
        this.baseGameWin = baseGameWin;
        this.jackpotUpgradeIndex = 0;

        this.totalFGSessionWin = baseGameWin;

        this.firstSpin = true;
        this.boundShakeEffect = this.shakeEffect.bind(this);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);

        this.pointerDownHandlerFree = this.onBannerPointerDown.bind(this);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);
        //PerformanceProfiler.increment('sceneCreated');
    }

    private async handleFeature(): Promise<void> {
        return new Promise((resolve) => {
            if (spinData.respins[RespinIndex.value].type === "fs_rip_activated") {
                console.log("rip activated");
            } else {
                resolve();
            }
        });
    }

    public async constructorWithAssets(): Promise<void> {
        this.initBaseLayering('backgroundFree', 'freeBackgroundSkel', 'freeBackgroundAtlas');
        this.setupTransition();

        DisplayComponent.register(new DisplayComponentFactory(ReelComponent));
        DisplayComponent.get(ReelComponent).init();
        this.reels = DisplayComponent.get(ReelComponent).getInstance();
        this.setupReelFrame("reelBackSkel", "reelBackAtlas", false);

        this.setupCommonUI();
        this.createUpgradeText();
        this.setupJackpotUpgradeComponent();
        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.addChild(this.bigWin);

        this.resize(Manager.screenwidth, Manager.screenHeight);
    }

    public shakeEffect = () => {
        let duration = 250;
        let intensity = 20;

        const original = { x: this.x, y: this.y };
        const offset = { x: 0, y: 0 };

        new Tween(offset)
            .to({ x: 0, y: 0 }, duration)
            .onUpdate(() => {
                this.x = original.x + (Math.random() - 0.5) * intensity;
                this.y = original.y + (Math.random() - 0.5) * intensity;
            })
            .onComplete(() => {
                this.x = original.x;
                this.y = original.y;
            })
            .start();
    }

    private upgradeTextContainer!: Container;

    private jackpotTitle!: Text;
    private upgradedTitle!: Text;
    private jackpotAmount!: BitmapText;

    private setUpgradeTextContent(jackpotValue: number): void {
        const translated = translationManager.game("jackpot_upgrade_desc", null);
        const { jackpot, upgraded } = parseJackpotUpgradeDesc(translated);

        this.jackpotTitle.text = jackpot;
        this.upgradedTitle.text = upgraded;
        // this.jackpotAmount.text = `${jackpotValue}x`;
        console.log(jackpotValue)
        layoutJackpotUpgradeText(this.jackpotTitle, this.upgradedTitle, this.jackpotAmount);
    }

    private createUpgradeText(): void {
        const {
            fontFamily: fontFamilyHeading,
            fontWeight: fontWeightHeading,
        } = getFontConfig(languageGlobal, "jackpotHeading");

        this.upgradeBlackLayer.rect(-10000, -10000, 20000, 20000).fill(0x000000);
        this.upgradeBlackLayer.alpha = 0.65;
        this.upgradeBlackLayer.visible = false;
        this.game.addChild(this.upgradeBlackLayer);

        this.upgradeTextContainer = new Container();
        this.upgradeTextContainer.label = "upgradeTextContainer";
        this.upgradeTextContainer.visible = false;

        this.jackpotTitle = new Text({
            text: "",
            style: createUpgradeTitleStyle(fontFamilyHeading, fontWeightHeading, JACKPOT_UPGRADE_TITLE_FONT_SIZE),
        });
        this.jackpotTitle.anchor.set(0.5);

        this.upgradedTitle = new Text({
            text: "",
            style: createUpgradeTitleStyle(fontFamilyHeading, fontWeightHeading, JACKPOT_UPGRADE_TITLE_FONT_SIZE),
        });
        this.upgradedTitle.anchor.set(0.5);

        this.jackpotAmount = new BitmapText({
            text: "",
            style: {
                fontFamily: "scarab_wins_digit",
                fontSize: JACKPOT_UPGRADE_AMOUNT_FONT_SIZE,
                align: "center",
            },
        });
        this.jackpotAmount.anchor.set(0.5);

        this.upgradeTextContainer.addChild(
            this.jackpotTitle,
            this.upgradedTitle,
            this.jackpotAmount
        );

        this.upgradeTextContainer.position.set(
            GameConstants.BACKGROUND_SIZE / 2,
            GameConstants.BACKGROUND_SIZE / 2
        );

        this.game.addChild(this.upgradeTextContainer);
    }

    private appearUpgradeText(): Promise<void> {
        const jackpotValue = getJackpotEntryByIndex(this.jackpotUpgradeIndex)?.value || 0;
        this.setUpgradeTextContent(jackpotValue);
        this.jackpotUpgradeIndex++;

        return new Promise<void>(async (resolve) => {
            const dustAnim = Spine.from({
                skeleton: "bannerDustSkel",
                atlas: "bannerDustAtlas",
            });
            dustAnim.position.set(GameConstants.BACKGROUND_SIZE / 2 - 275, GameConstants.BACKGROUND_SIZE / 2);
            this.game.addChild(dustAnim);
            dustAnim.state.setAnimation(0, "in", false);
            dustAnim.state.addAnimation(0, "loop", true, 0);

            this.upgradeBlackLayer.visible = true;
            this.upgradeTextContainer.visible = true;
            const targetScale = Math.min(950 / this.upgradeTextContainer.width, 1);

            this.upgradeTextContainer.scale.set(0.01);
            sound.play(SoundConstants.JACKPOT_UPGRADED, { volume: 0.8 });
            await new Tween(this.upgradeTextContainer.scale)
                .to({ x: targetScale, y: targetScale }, 200)
                .start()
                .onComplete(async () => {

                    await (isSuperQuickBtnOnGlobal ? wait(1000) : wait(2000));

                    dustAnim.state.setAnimation(0, "out", false);

                    dustAnim.state.addListener({
                        complete: () => {
                            dustAnim.destroy({ children: true });
                        }
                    });

                    await new Tween(this.upgradeTextContainer.scale)
                        .to({ x: 0, y: 0 }, 200)
                        .start()
                        .onComplete(() => {
                            this.upgradeBlackLayer.visible = false;
                            this.upgradeTextContainer.visible = false;
                            this.upgradeTextContainer.scale.set(1);

                            resolve();
                        })

                });
        });
    }

    public showJackpotIntroBanner() {
        return new Promise<void>(async (resolve) => {
            DisplayComponent.get(JackpotIntroBannerComponent).play(resolve);
        });
    }

    private publishInitialFeatureMeterState(): void {
        Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
        Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((this.baseGameWin * 100).toFixed(0));
    }

    public async beginFeaturePlay(): Promise<void> {
        this.publishInitialFeatureMeterState();
        Manager.casinoChannelHandler.reportFeatureRoundStarted();
        this.skipNextFeatureRoundStarted = true;
        await this.showJackpotIntroBanner();
        await this.freeSpinPlay();
    }

    private startFeatureRoundIfNeeded(): void {
        if (this.skipNextFeatureRoundStarted) {
            this.skipNextFeatureRoundStarted = false;
            return;
        }
        Manager.casinoChannelHandler.reportFeatureRoundStarted();
    }

    public async freeSpinPlay() {
        // this point to start the transition animation
        this.fgTransition.state.setAnimation(0, "animation", false);

        console.log("this.numberOfFS", this.numberOfFS);

        // this.ui?.resetWinValue();

        const fsRevealIndexes = spinData.respins
            .map((respin, index) => (respin.type === "fs_reveal" ? index : -1))
            .filter(index => index !== -1);

        console.log("fsRevealIndexes", fsRevealIndexes);

        let freeGameTrigger = 1;
        let winAmount: number;
        let accumulatedsWinAmount: number;
        let isFeatureTrigger: boolean;

        while (freeGameTrigger != -1 && freeGameTrigger != -2) {

            this.startFeatureRoundIfNeeded();
            // let firstSpinMeterPromise: Promise<void> | null = null;

            if (this.firstSpin) // brief delay before first spin (meter already set in beginFeaturePlay)
            {
                this.firstSpin = false;
                await new Promise(resolve => setTimeout(resolve, 500));

                // await at this point to get transition animation emitt a singnal to start ie, event named "change"
                // if (this.transitionChangePromise) {
                //     await this.transitionChangePromise;
                //     console.log("'change' event awaited and received in freeSpinPlay");
                // }

            }

            if (spinData.respins[RespinIndex.value].type === "fs_rip_activated") {

            } else {
                this.numberOfFS = this.numberOfFS - 1;
                if (this.numberOfFS >= 0) {
                    Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);
                    this.numberOfFSPlayed = this.numberOfFSPlayed + 1;
                }
            }

            [freeGameTrigger, winAmount, accumulatedsWinAmount, isFeatureTrigger] = await this.spinReel();

            console.log("Freegame while loop for", RespinIndex.value, freeGameTrigger, "winAmount", winAmount, "accumulatedsWinAmount", accumulatedsWinAmount, "isFeatureTrigger", isFeatureTrigger);
            if (spinData.respins[RespinIndex.value - 1]?.featureData?.featureName === GameConstants.FEATURE_TYPE_2) {
                await this.scarabCollect();
            }
            if (spinData.respins[RespinIndex.value - 1].featureData.scarabWinData.winAmount > 0) {
                await DisplayComponent.get(JackpotUpgradeComponent).showBonusCompletedBanner();
                console.log("Final JP win");
                await new Promise(resolve => setTimeout(resolve, 500));
            }

            Manager.casinoChannelHandler.reportFeatureRoundCompleted((winAmount * 100).toFixed(0));
            if (winAmount > 0 && freeGameTrigger != -1) {
                await this.bigWin.bigWinFunction(winAmount);
            }


            const featureWinCentsNum = Math.floor(winAmount * 100);
            console.log("reportUpdateFeatureTotalWin", featureWinCentsNum);

            Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((accumulatedsWinAmount * 100).toFixed(0));

            if (winAmount > 0) {
                await new Promise(resolve => setTimeout(resolve, 200));
            }


            // if (spinData.respins[RespinIndex.value - 1]?.featureData?.featureName === GameConstants.FEATURE_TYPE_2) {
            //     await this.scarabCollect();
            // }

            if (freeGameTrigger > 0) {

                console.log("RespinIndex.value", RespinIndex.value);
                await this.reels?.processWinFeatureSymbol();

                this.numberOfFS = freeGameTrigger;


                await this.appearUpgradeText();

                await this.reelUpgrade();

                Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.numberOfFS);

                await wait(1000);

            }

            if (isFeatureTrigger) {
                await this.handleFeature();
                RespinIndex.increase();
            }

            // if (freeGameTrigger == -1 || freeGameTrigger == -2) {
            //     await DisplayComponent.get(JackpotUpgradeComponent).showBonusCompletedBanner();
            // }

            // if (winAmount > 0 && freeGameTrigger != -1) {
            //     await this.bigWin.bigWinFunction(winAmount);
            // }

            // Manager.casinoChannelHandler.reportFeatureRoundCompleted((winAmount * 100).toFixed(0));

            // const featureWinCentsNum = Math.floor(winAmount * 100);
            // console.log("reportUpdateFeatureTotalWin", featureWinCentsNum);

            // Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((accumulatedsWinAmount * 100).toFixed(0));

            // if (winAmount > 0) {
            //     await new Promise(resolve => setTimeout(resolve, 200));
            // }

            if (freeGameTrigger == -1 || freeGameTrigger == -2) {
                this.totalFGSessionWin = accumulatedsWinAmount;
            }
        }

        console.log("Freegame while loop exit");

        if (Manager.banner) {

            if (freeGameTrigger === -2) { // max win reached
                setMaxWinBtnClosedGlobal(false);
                Manager.casinoChannelHandler.reportMaxWin();

                // wait here till isMaxWinBtnClosedGlobal == true;

                await waitUntilMaxWinBtnClosed();

            }

            // await DisplayComponent.get(JackpotUpgradeComponent).showBonusCompletedBanner();

            Manager.casinoChannelHandler.reportFeatureExit();
            await Manager.banner.appearFreeGameOutroBanner(this.totalFGSessionWin, this.numberOfFSPlayed);

            if (willBannerAutoProceedGlobal) {
                this.callExitFreeGameAuto();
            }

            console.log("appearFreeGameOutroBanner");

            Manager.banner.on('pointerdown', this.pointerDownHandlerFree);

        }


    }

    private scarabCollect() {
        return new Promise<void>(async (resolve) => {
            await DisplayComponent.get(ScarabWinsComponent).startCollectFeature(RespinIndex.value - 1, resolve);
        });
    }

    private reelUpgrade(): Promise<void> {
        return new Promise<void>(async (resolve) => {
            DisplayComponent.get(JackpotUpgradeComponent).startFeature(resolve);
        });
    }

    private callExitFreeGameAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            clearTimeout(this.autoTriggerTimeout);
            console.log("calling freeGameSceneChnage exitFreeGame pointerdown auto");
            Manager.banner.off('pointerdown', this.pointerDownHandlerFree);
            this.exitFreeGame();
        }, 10000); // 10 seconds
    }

    private onBannerPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage exitFreeGame pointerdown")

        Manager.banner.off('pointerdown', this.pointerDownHandlerFree);
        this.exitFreeGame();
    }

    private async exitFreeGame() {

        console.log("casinoChannel-featureExit");
        if (!Manager.banner) return;

        // Manager.banner.startTransition();
        const bannerOutPromise = Manager.banner.disappearBanner();

        await wait(500);
        const game = new BaseGameScene();
        await Manager.changeScene(game, false);
        console.log("in freegame exit befor bannerout Promise");
        await bannerOutPromise;
        console.log("in freegame exit after bannerout Promise");
        Manager.casinoChannelHandler.reportGameRoundCompleted();
    }

    private async spinReel(): Promise<[number, number, number, boolean]> {

        let freeGameTrigger = 0;
        let winAmount = 0;
        let accumulatedsWinAmount = 0;
        let isFeatureTrigger = false;

        if (this.reels) {

            [freeGameTrigger, winAmount, accumulatedsWinAmount, isFeatureTrigger] = await this.reels.startPlay("FREEGAME");

            console.log("freeGameTrigger", freeGameTrigger);
            console.log("winAmount", winAmount);

            // this.reels?.setReelRunning(false);
        }

        return [freeGameTrigger, winAmount, accumulatedsWinAmount, isFeatureTrigger];

    }

    private setupTransition(): void {
        this.fgTransition = Spine.from({
            skeleton: "bannerTransitionSkel",
            atlas: "bannerTransitionAtlas"
        });
        this.fgTransition.label = "fgTransition";

        // Create a Promise that resolves on 'change' event
        // this.transitionChangePromise = new Promise<void>((resolve) => {
        //     this.resolveTransitionChange = resolve;
        // });

        this.fgTransition.state.addListener({
            start: () => {
                console.log("fgTransition Started");
            },
            // event: (_entry, event) => {
            //     if (event.data.name === "event") {
            //         console.log("fgTransition emitted 'change' event");

            //         if (this.resolveTransitionChange) {
            //             this.resolveTransitionChange();
            //             this.resolveTransitionChange = null; // prevent multiple calls
            //         }

            //     }
            // },
            complete: () => {

                this.fgTransition.destroy();
                this.fgTransition = null;
                console.log("fgTransition completed");
            }
        });
    }

    private setupJackpotUpgradeComponent() {
        DisplayComponent.register(new DisplayComponentFactory(JackpotUpgradeComponent));
        DisplayComponent.get(JackpotUpgradeComponent).init();

        this.addComponent(JackpotIntroBannerComponent, this.game);
        this.addComponent(JackpotWinBannerComponent, this.game);
    }

    public override destroy() {
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);
        DisplayComponent.unregister(JackpotUpgradeComponent);
        DisplayComponent.unregister(JackpotIntroBannerComponent);
        DisplayComponent.unregister(JackpotWinBannerComponent);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        Assets.unload(['backgroundFree', 'freeBackgroundSkel', 'freeBackgroundAtlas']);
        super.destroy();
    }

    public override resize(screenWidth: number, screenHeight: number): void {
        super.resize(screenWidth, screenHeight);
        let orientationScale = (Manager.Orientation === "LANDSCAPE") ? REEL_SCALE_LANDSCAPE[VISIBLE_SYMBOLS_PER_REEL - 3] : REEL_SCALE_PORTRAIT[VISIBLE_SYMBOLS_PER_REEL - 3];
        this.reels.scale.set(orientationScale);
        let orientationYPos = (Manager.Orientation === "LANDSCAPE") ? (REEL_Y_POS_LAND[VISIBLE_SYMBOLS_PER_REEL - 3]) : REEL_Y_POS_PORT[VISIBLE_SYMBOLS_PER_REEL - 3];
        this.reelFrame.position.y = orientationYPos;
    }
}
